import { GroupListItem } from "@/src/models/group.model";
import { useTheme } from "@/src/styles/theme-provider";
import { Global, Lock } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Image, Pressable, Text, View } from "react-native";

const defaultCover = require("@/src/assets/images/default-group-cover.png");

type LatestGroupsCardProps = Readonly<{
  latestGroups: GroupListItem[];
  onSelect?: (id: string) => void;
}>;

const LatestGroupsCard = ({ latestGroups, onSelect }: LatestGroupsCardProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();
  const mutedColor = themeVars["--color-slate-default"] as string;

  return (
    <View className="bg-chalk rounded-xl border border-ash-3 p-4">
      <Text className="text-sm font-bold text-onyx mb-3">
        {t("LABEL_LATEST_GROUPS")}
      </Text>

      <View className="gap-3">
        {latestGroups.length === 0 ? (
          <Text className="text-xs text-slate">{t("LABEL_NO_GROUPS")}</Text>
        ) : (
          latestGroups.map((group) => (
            <Pressable
              key={group.ItemId}
              className="flex-row items-center gap-3 border border-ash-3 p-2 rounded-xl active:bg-ash-3 web:hover:bg-ash-3"
              onPress={() => onSelect?.(group.ItemId)}
            >
              {/* Circular cover image */}
              <Image
                source={
                  group.coverImageUrl
                    ? { uri: group.coverImageUrl }
                    : defaultCover
                }
                style={{ width: 44, height: 44, borderRadius: 22 }}
                resizeMode="cover"
              />

              {/* Title + status */}
              <View className="flex-1">
                <Text
                  className="text-sm font-semibold text-onyx"
                  numberOfLines={1}
                >
                  {group.name}
                </Text>

                <View className="flex-row items-center gap-1 mt-0.5">
                  {group.isPrivate ? (
                    <Lock size={12} color={mutedColor} variant="Linear" />
                  ) : (
                    <Global size={12} color={mutedColor} variant="Linear" />
                  )}
                  <Text className="text-xs text-slate">
                    {group.isPrivate
                      ? t("LABEL_PRIVATE_GROUP")
                      : t("LABEL_PUBLIC_GROUP")}
                  </Text>
                </View>
              </View>
            </Pressable>
          ))
        )}
      </View>
    </View>
  );
};

export default LatestGroupsCard;
